import config from '../../config'

import {Permission, ProviderId} from '../../types'

import httpJsonAuth from '../http-json-auth'

type PermissionsResponse = {
  permissions: Permission
  provider: ProviderId | null
  apiKeyExpiresAt: Date | null
}

export const getUserPermissions = async (userId: string): Promise<PermissionsResponse> => {
  const response = await httpJsonAuth.fetch(`${config.services.api.baseUrl}/user/${userId}`)
  return response.json
}

export const generateApiKey = async (userId: string): Promise<{apiKey: string}> => {
  const response = await httpJsonAuth.fetch(
    `${config.services.api.baseUrl}/user/api-key/generate`,
    {
      method: 'POST',
      body: {userId},
    }
  )
  return response.json
}
